import { createActions } from "src/utils/reduxsauce";

const { Types, Creators } = createActions(
  {
    setPageState: { args: ["payload"] },
  },
  {
    prefix: "@app/page/"
  }
);

export const ActionTypes = Types;
export default Creators;
export const PageActions = Creators;
